export enum MIME_TYPES  {
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
}